import { render, staticRenderFns } from "./ControleBnpRosca.vue?vue&type=template&id=241f3e3d&scoped=true&"
import script from "./ControleBnpRosca.vue?vue&type=script&lang=js&"
export * from "./ControleBnpRosca.vue?vue&type=script&lang=js&"
import style0 from "./ControleBnpRosca.vue?vue&type=style&index=0&id=241f3e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f3e3d",
  null
  
)

export default component.exports